import { BenefitsSection } from "../BenefitsSection";

import MainLayout from "@/layouts/MainLayout";
import type { NextPage } from "next";
import { AnalysisResultSection } from "../AnalysisResultSection";
import { WhyDNACanvasHeadingSection } from "../HeadingSection";

export const WhyDNACanvasPage: NextPage = () => {
  return (
    <MainLayout footerBackgroundColor="info.100">
      <WhyDNACanvasHeadingSection />
      <BenefitsSection />
      <AnalysisResultSection />
    </MainLayout>
  );
};
